import { useEffect, useState } from "react";

import OptionalFields, { ToggleButton } from "../../../../components/optionalFieds";
import FloatingLabelDate from "../../../../components/floatingLabelDate";
import FloatingLabelInput from "../../../../components/floatingLabelInput";
import FloatingLabelSelect from "../../../../components/floatingLabelSelect";
import FloatingLabelTextArea from "../../../../components/floatingLabelTextArea";
import { formatPhoneNumber, formatDollarWithComma, formatDate, earliestStartDate } from "../../../../features/utils";
import { BDS_TEAM_LEAD_TITLE, RIZE_CO_TEAM_LEAD_TITLES, isOverrideOnlyTitle, isRizeForRealtorFlow, managementTitleOptions } from "../../../../config/flows";
import ModalShell from "./modalShell";
import AssignedLoanOfficers from "./assignedLoanOfficers";
import { showValidationError } from "../../../components/onboarding/apiHelper";


const initialData = {
    tentativeStartDate: formatDate(new Date()),
    firstName: '',
    lastName: '',
    title: 'Area Manager',
    email: '',
    cellNumber: '',
    employementType: 'Salary, Full Time (Recoverable)',
    compensationRate: '',
    isOriginatingLoans: false,
    isShowTransactions: false,
    transactions: [
        {   label: 'Self Generated Transactions (bps)', 
            value: '', isBoxToggled: true, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: true, 
            helpText: 'Comp paid for loans sourced by the Loan Officer directly (required)' 
        },
        {   label: 'Self Generated Refinance Transactions (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'Comp paid for Refinance loans sourced by the Loan Officer directly' 
        },
        {   label: 'Branch Generated Loan (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'Comp paid for loans where the lead was provided by the branch/corporate and/or accounts sourced or assigned by the branch or corporate (examples may be builders or real estate offices)' 

        },
        { label: 'Branch Generated Loan Refinance (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'Comp paid for Refinance loans where the lead was provided by the branch/corporate and/or accounts sourced or assigned by the branch or corporate (examples may be builders or real estate offices)' 

        },
        { label: 'Self Generated Consumer Paid Brokered Out Split (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'A traditional split on Borrower Paid Brokered out transactions only based on the gross revenue received by the company.  (example Borrower pays 2 points on a brokered transaction and has a 60% split, LO would receive 1.2%, again does not apply to Lender paid brokered out transactions.)' 

        },
        { label: 'Branch Generated Consumer Paid Brokered Out Split (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Branch Relationship Generated Consumer Paid Brokered Out Split (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Branch To Branch Referral (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'Comp paid for loans referred into the Rize Mortgage Specialty desk.  (common examples are out of state and bond loans that have SRP restrictions)' 

        },
        { label: 'Co-Originated Loan Split (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'A percentage Comp that a Loan Officer will receive if they originate a Loan with another LO (example LO 1 has a self gen comp of 150 bps with a Co-Origination split of 50% and LO 2 has a LO comp of 130 bps with a Co-Origination split of 60%.  LO 1 would receive 75 bps and LO 2 would receive 78 bps, this can be applied to all comp types)' 

        },
        { label: 'Self Generated Open Ended Credit (HELOC & Open Ended HECM) (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'A traditional split on Loans generated by the Loan Officer for all loans defined as open ended credit (example HELOC or open ended reverse mortgage)' 

        },
        { label: 'Company Generated Open Ended Credit (HELOC & Open Ended HECM) (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: 'A traditional split on Loans where the lead was provided by the branch/corporate and/or accounts sourced or assigned by the branch or corporate for all loans defined as open ended credit (example HELOC or open ended reverse mortgage)' 

        },
        { label: 'Branch Generated Relationship (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Branch Generated Relationship Refinance (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Speciality Desk Referral (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Transition Comp (bps)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
        { label: 'Branch Relationship Generated Open Ended Credit (HELOC & Open Ended HECM) (%)', 
            value: '', isBoxToggled: false, isMaxCompensation: false, 
            maxCompensation: '', isToggleHidden: false, 
            helpText: '' 

        },
    ],
    bonus: { _option: false, value: '' },
    upfront: { _option: false, value: '' },
    overrideBps: '',
    assigned_loan_officers: [],
    notes: '',
    reportingManager: '',
    filledBy: 'admin',
}


/** Cleared every time the modal is opened, so no message survives from last time. */
const initialError = {
    firstName: '',
    lastName: '',
    cellNumber: '',
    email: '',
    bonus: '',
    upfront: '',
};

const CoManagerInfoModal = ({ isOpen, onboardingForm, onSave, handleModalClose, coManagerData=null, index=null, flowType='' }) => {
    const isRizeTeam = isRizeForRealtorFlow(flowType);
    const [data, setData] = useState(initialData);
    // Business Development positions are paid by Override (BPS), not salary
    const isOverrideOnly = isOverrideOnlyTitle(data.title);
    const [error, setError] = useState(initialError);

   useEffect(() => {
    if (!isOpen) return;
    const mergedData = (coManagerData && Object.keys(coManagerData).length > 0)
        ? { ...initialData, ...coManagerData }
        : { ...initialData };
    // The default "Area Manager" is not offered for a Rize for Realtor team
    if (isRizeTeam && !RIZE_CO_TEAM_LEAD_TITLES.includes(mergedData.title)) {
        mergedData.title = BDS_TEAM_LEAD_TITLE;
    }
    setData(mergedData)
    setError(initialError);
   }, [isOpen, coManagerData, isRizeTeam])

    const filteredArray = onboardingForm.filter((item) => item.Title === data.title);
    const employmentTypeOptions = filteredArray.length > 0
        ? JSON.parse(filteredArray[0].EmploymentType).map(option => ({ label: option, value: option }))
        : [];

    // For a Rize for Realtor team only the Business Development titles apply.
    // If none of them are in the dropdown data yet, fall back to the full list.
    const rizeTitleOptions = onboardingForm.filter((item) => RIZE_CO_TEAM_LEAD_TITLES.includes(item.Title));
    const titleOptions = (isRizeTeam && rizeTitleOptions.length > 0)
        ? rizeTitleOptions
        : managementTitleOptions(onboardingForm);

    // Keep the shown/saved employment type inside the available options (the default
    // "Salary, ..." is not offered for a Business Development title)
    const employmentTypeValue = employmentTypeOptions.some(option => option.value === data.employementType)
        ? data.employementType
        : (employmentTypeOptions[0]?.value || '');

    // const handleSave = (e) => {
    //     e.preventDefault()
    //     const isFormValid = Object.values(error).every((error) => error === '');
    //     if (!isFormValid) {
    //         alert("Please fill the valid data.");
    //         return;
    //     }
    //     onSave(data, index);
    //     setData(initialData);
    //     handleModalClose();
    // }

    const handleSave = (e) => {
        e.preventDefault();
        const keys = Object.keys(error)
        console.log(keys)
        for (let key of keys) {
            if (error[key] !== '') {
                console.log(error)
                showValidationError(error[key]);
                return;
            }
        }
        if (String(data.cellNumber || '').replace(/[^\d]/g, '').length !== 10) {
            showValidationError('Please enter a valid 10 digit Cell Number for the Co Team Lead.');
            return;
        }
        if (isOverrideOnly && !data.overrideBps) {
            showValidationError(`Please enter the Override (BPS) for the ${data.title}.`);
            return;
        }
        onSave({
            ...data,
            employementType: employmentTypeValue,
            // Business Development positions are paid by override, not salary
            overrideBps: isOverrideOnly ? data.overrideBps : '',
            compensationRate: isOverrideOnly ? '' : data.compensationRate,
            // Loan Officers are only assigned to a Rize for Realtor team
            assigned_loan_officers: isRizeTeam ? (data.assigned_loan_officers || []) : [],
        }, index);
        setData(initialData);
        handleModalClose();
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'firstName') {
            const first_name_input = e.target.value.replace(/\s/g, '');
            setData({...data, [name]: first_name_input});
            setError({...error, [name]: ''});
        }
        else if (name === 'cellNumber') {
            // Nothing is flagged while the number is still being typed — it is
            // checked on blur and again on save. formatPhoneNumber truncates to 10
            // digits, so a further keystroke leaves a valid number in the field.
            setData({...data, [name]: formatPhoneNumber(value)});
            setError({...error, [name]: ''});
        }
        else if (name === 'email') {
            setData({...data, [name]: value})
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setError({...error, [name]: 'Please enter a valid email address'});
            } else {
                setError({...error, [name]: ''})
            }
        }
        else if (name === 'compensationRate') {
            setData({ ...data, [name]: formatDollarWithComma(value)});
            setError({...error, [name]: ''});
        }
        else if (name === 'overrideBps') {
            // The API parses this as a number, so keep a single decimal point
            const [whole, ...decimals] = value.replace(/[^\d.]/g, '').split('.');
            setData({ ...data, [name]: decimals.length ? `${whole}.${decimals.join('')}` : whole });
            setError({...error, [name]: ''});
        }
        else {
            setData({...data, [name]: value});
            setError({...error, [name]: ''});
        }
    }

    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === 'cellNumber') {
            // An untouched field is not invalid — `required` covers an empty one on
            // submit. Only a half typed number is flagged, and a complete one clears
            // the message again.
            const rawNumbers = value.replace(/[^\d]/g, '');
            setError({
                ...error,
                [name]: rawNumbers.length === 0 || rawNumbers.length === 10 ? '' : 'Please enter a valid phone number',
            });
        }
        else if (name === 'email') {
            var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(value)) {
                setError({...error, [name]: 'Please enter a valid email address'});
            }
        }
        // else {
        //     if (value === '') {
        //         setError({...error, [name]: `${name} is required.`});
        //     }
        // }
        
      };

    

    const handleIsShowTransactions = () => {
        setData({...data, isShowTransactions: !data.isShowTransactions});
    }

    const handleIsOriginatingLoans = () => {
        setData({ 
            ...data, 
            isOriginatingLoans: !data.isOriginatingLoans,
            isShowTransactions: data.isOriginatingLoans ? false : true
        });
    }

    const handleOptionFieldChange = (index, value) => {
        setData(currentData => ({
            ...currentData,
            transactions: currentData.transactions.map((item, i) => 
                                i === index 
                                ? {
                                    ...item, value: parseFloat(value)
                                } 
                                : item)
        }))
    }

    const handleOptionFieldToggle = (index) => {
        setData(currentData => ({
            ...currentData,
            transactions: currentData.transactions.map((item, i) => 
                                    i === index 
                                    ? {
                                        ...item, isBoxToggled: !item.isBoxToggled
                                    } 
                                    : item)
        }))
    }


    const handleMaxCompensationToggle = (index) => {  
        // if maxCompensation is not toggled, make input field empty              
        setData(currentData => ({
            ...currentData,
            transactions: currentData.transactions.map((item, i) => 
                                        i === index 
                                        ?   {
                                                ...item, 
                                                isMaxCompensation: !item.isMaxCompensation,
                                                maxCompensation: !item.isMaxCompensation ? item.maxCompensation : ''
                                            } 
                                        : item
                                )
        }))
    }

    const handleMaxCompensationFieldChange = (index, value) => {    
        setData(currentData => ({
            ...currentData,
            transactions: currentData.transactions.map((item, i) => 
                                        i === index 
                                        ?   {
                                                ...item, 
                                                maxCompensation: formatDollarWithComma(value)
                                            } 
                                        : item
                        )
        }))

    }


    const handleAssignedLoanOfficersChange = (officers) => {
        setData(currentData => ({ ...currentData, assigned_loan_officers: officers }));
    }


    const handleAdditionQuestionsChange = (e) => {
        const { name, value } = e.target;
        setData({...data, [name]: {...data[name], value: value}});
        setError({...error, [name]: ''});

    }

    const handleAdditionQuestionToggle = (name) => {
        setData({...data, [name]: {...data[name], _option: !data[name]._option}});
    }


    if (!isOpen) return null;

  
    const isEditing = coManagerData && Object.keys(coManagerData).length > 0;

    return (
        <ModalShell
            title="Available for your New Hire"
            subtitle={isEditing ? 'Edit the Co Team Lead details' : 'Add the Co Team Lead details'}
            onClose={handleModalClose}
        >
                <form onSubmit={handleSave} className="rize-modal-form profile-review-scrollbar flex-1 overflow-y-auto overscroll-contain px-5 pt-6 sm:px-8">
                    <div className="mx-auto max-w-3xl">
                        <div>
                            <div className="space-y-8">
                                <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-3">
                                        <FloatingLabelDate
                                                label="Tentative Start Date" 
                                                handleChange={handleChange} 
                                                value={data.tentativeStartDate} 
                                                name="tentativeStartDate" 
                                                id="tentative_start_date_" 
                                                required={true}
                                                min={earliestStartDate(data.tentativeStartDate)}
                                            />
                                    </div>
                                </div>
                                <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-3">
                                        <FloatingLabelInput 
                                                handleChange={handleChange} 
                                                handleBlur={handleBlur}
                                                value={data.firstName}
                                                error={error.firstName}
                                                name="firstName" 
                                                id="first_name_" 
                                                label="Co Team Lead First Name"
                                                required={true}
                                            />
                                    </div>
                                    <div className="sm:col-span-3">
                                        <FloatingLabelInput 
                                                handleChange={handleChange} 
                                                handleBlur={handleBlur}
                                                value={data.lastName} 
                                                error={error.lastName} 
                                                name="lastName" 
                                                id="last_name_" 
                                                label="Co Team Lead Last Name"
                                                required={true}
                                            />
                                    </div>
                                </div>
                                
                                <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-3">
                                        <FloatingLabelInput 
                                                handleChange={handleChange} 
                                                handleBlur={handleBlur}
                                                value={data.cellNumber} 
                                                error={error.cellNumber}
                                                name="cellNumber" 
                                                id="cell_number_" 
                                                type="tel" 
                                                label="Co Team Lead Cell Number"
                                                required={true}
                                            />
                                    </div>
                                    <div className="sm:col-span-3">
                                        <FloatingLabelInput 
                                                handleChange={handleChange} 
                                                handleBlur={handleBlur}
                                                value={data.email} 
                                                error={error.email}
                                                name="email" 
                                                id="email_" 
                                                type="email" 
                                                label="Co Team Lead Personal Email Address"
                                                required={true}
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-10 mb-8 pt-8 border-t border-slate-200">
                                <h3 className="text-lg font-semibold text-[#0a1445]">
                                    Position and Compensation Information
                                </h3>
                            </div>
                            <div className="space-y-8">
                                <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-3">
                                        <FloatingLabelSelect 
                                                handleChange={handleChange} 
                                                value={data.title} 
                                                error={error.title} 
                                                name="title" 
                                                id="title_" 
                                                label="Co Team Lead Position / Title"
                                                options={titleOptions}
                                                required={true}
                                            />
                                    </div>

                                    <div className="sm:col-span-3">
                                        <FloatingLabelSelect
                                                handleChange={handleChange}
                                                value={employmentTypeValue}
                                                error={error.employementType}
                                                name="employementType"
                                                id="employement_type_"
                                                label="Employment Type"
                                                options={employmentTypeOptions}
                                                required={true}
                                            />
                                    </div>
                                </div>
                                {/* Override / Bonus based compensation — Business Development positions */}
                                {isOverrideOnly && (
                                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                        <div className="sm:col-span-3">
                                            <FloatingLabelInput
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={data.overrideBps}
                                                error={error.overrideBps}
                                                name="overrideBps"
                                                id="override_bps_"
                                                type="text"
                                                label="Override (BPS)"
                                                required={true}
                                            />
                                        </div>
                                        <div className="sm:col-span-3">
                                            <p className="pt-2 text-sm text-gray-500">
                                                Compensation for this position is override / bonus based — no salary.
                                            </p>
                                        </div>
                                    </div>
                                )}
                                { !isOverrideOnly && filteredArray.length > 0 && filteredArray[0].CompensationRateBox === "true" && (
                                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                                        <div className="sm:col-span-3">
                                        <FloatingLabelInput
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={data.compensationRate}
                                            name="compensationRate"
                                            id="compensation_rate_"
                                            type="text"
                                            label={`Compensation Rate ($)${
                                                employmentTypeOptions.length > 0
                                                ? employmentTypeOptions[0].value.toLowerCase().includes("hourly")
                                                    ? " /hour"
                                                    : " /year"
                                                : ""
                                            }`}
                                            isCurrency={true}
                                            required={true}
                                        />
                                        </div>
                                        {/* <div className="sm:col-span-3">
                                            <p className="pt-2">
                                                { employmentTypeOptions.length > 0 && 
                                                    (employmentTypeOptions[0].value.toLowerCase().includes("hourly") ?
                                                        "/hour"
                                                    : "/year"
                                                    )
                                                }
                                            </p>
                                        </div> */}
                                    </div>
                                )}
                            </div>

                            {/*
                                Will this employee be originating loans? (yes or no toggle) 
                                Right above Does this position offer LO Comp? 
                                If no, Does this poision offer LO Comp will be no and hidden. 
                                NMLS number becomes mandatory in the wizzard 
                            */}
                            <div className="grid grid-cols-12 gap-8 mb-10">
                                <div className="col-span-8 mb-4">
                                        <ToggleButton
                                            label="Will this employee be originating loans?"
                                            isToggled={data.isOriginatingLoans}
                                            handleToggle={handleIsOriginatingLoans}
                                            name="originationLoans_"
                                        />
                                </div>
                            </div>

                            {/* Loan Officer(s) assigned to the Rize for Realtor team */}
                            {isRizeTeam && (
                                <AssignedLoanOfficers
                                    officers={data.assigned_loan_officers || []}
                                    onChange={handleAssignedLoanOfficersChange}
                                    description="Add the Loan Officer(s) that will be assigned to this Co Team Lead's team."
                                />
                            )}

                            {/* LO Comp */}
                            {filteredArray.length > 0 && filteredArray[0].ShowCommisionToggle && data.isOriginatingLoans &&  (
                                <div className="grid grid-cols-12 gap-8 mb-10">
                                    <div className="col-span-8 mb-4">
                                            <ToggleButton
                                                label="Does this position offer LO Comp?"
                                                isToggled={data.isShowTransactions}
                                                handleToggle={handleIsShowTransactions}
                                                name="showTransactions_"
                                            />
                                    </div>
                                </div>
                            )}
                            
                            { data.isShowTransactions && (
                                <div className="mt-10 mb-8 pt-8 border-t border-slate-200">
                                    <h3 className="text-lg font-semibold text-[#0a1445]">
                                        Please Select the Commission Compensation Buckets You Would Like to Have Available to Your New Hire
                                    </h3>
                                </div>
                            )}
                            {data.isShowTransactions && data.transactions.map((dataObject, index) => (
                                <OptionalFields
                                    handleOptionFieldChange={(e) => handleOptionFieldChange(index, e.target.value)} 
                                    handleOptionFieldToggle={() => handleOptionFieldToggle(index)}
                                    handleMaxCompensationToggle={() => handleMaxCompensationToggle(index)}
                                    handleMaxCompensationFieldChange={(e) => handleMaxCompensationFieldChange(index, e.target.value)}
                                    handleBlur={handleBlur} 
                                    data={dataObject}
                                    error={error}
                                    label={dataObject.label}
                                    name={ dataObject.label.replace(/\s/g, '')}
                                    key={index}
                                    />
                            ))}

                            {/* Additional Questions */}
                            <div className="grid grid-cols-12 gap-8 mt-10">
                                <div className="col-span-8 mb-4">
                                    <ToggleButton 
                                        label="Is there any type of override or bonus?" 
                                        isToggled={data.bonus._option}
                                        handleToggle={() => handleAdditionQuestionToggle('bonus')}
                                        name={'bonus__'}
                                    />
                                    
                                </div>
                            
                            </div>
                            <div className="grid grid-cols-1 gap-8 mb-10">
                            <div className="sm:col-span-3">
                                {data.bonus._option && (
                                        <FloatingLabelTextArea 
                                            handleChange={handleAdditionQuestionsChange} 
                                            handleBlur={handleBlur}
                                            value={data.bonus.value} 
                                            error={error.bonus}
                                            name={'bonus'} 
                                            id='bonus_'
                                            label="" 
                                            type='text'
                                            placeholder='Describe override or bonus'
                                            rows="3"
                                            required={true}
                                        />
                                    )}
                                </div>
                                </div>
                            <div className="grid grid-cols-12 gap-8">
                                <div className="col-span-8 mb-4 min-w-0">
                                    <ToggleButton 
                                        label="Is there any type of sign-on bonus or upfront incentive?" 
                                        isToggled={data.upfront._option}
                                        handleToggle={() => handleAdditionQuestionToggle('upfront')}
                                        name={'upfront__'}
                                    />
                                </div>
                                
                            </div>
                            <div className="grid grid-cols-1 gap-4 mb-10">
                                <div className="sm:col-span-3">
                                        {data.upfront._option && (
                                            <FloatingLabelTextArea 
                                                handleChange={handleAdditionQuestionsChange} 
                                                handleBlur={handleBlur}
                                                value={data.upfront.value} 
                                                error={error.upfront}
                                                name={'upfront'} 
                                                id={'upfront_'}
                                                label="" 
                                                type='text'
                                                placeholder='Describe Sign-on or upfront incentive terms'
                                                rows='3'
                                                required={true}
                                            />
                                        )}
                                </div>
                            </div>

                            {/* Text Area */}
                            <span className="font-medium">
                                Compensation and Other Notes regarding the new hire
                            </span>
                        
                            <div className="border rounded-md mt-4 mb-14">
                                <textarea
                                    type="text"
                                    id="notes_"
                                    value={data.notes}
                                    name="notes"
                                    rows="8" 
                                    cols="50"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    // required={true}
                                    placeholder='(ie sliding volume scale, yearly volume incentive, etc.)'
                                    className={`w-full pl-4 border-none outline-none ring-0 focus:ring-0 ${data.notes  ? 'bg-white' : 'bg-gray-50'}`}
                                />
                                
                            </div>

                            <div className='sticky bottom-0 z-10 -mx-5 mt-6 flex flex-col-reverse justify-end gap-3 border-t border-slate-200 bg-white px-5 py-4 sm:-mx-8 sm:flex-row sm:px-8'>
                                
                                <button 
                                    className="inline-flex h-11 w-full items-center justify-center rounded-xl border border-slate-300 bg-white px-5 text-sm font-semibold text-[#211b4f] hover:bg-slate-50 sm:w-auto"
                                    type='button'
                                    onClick={handleModalClose}
                                    >
                                        Cancel
                                </button>
                                <button
                                    className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#211b4f] px-6 text-sm font-semibold text-white shadow-sm hover:bg-[#30266c] sm:w-auto"
                                    type='submit'
                                    >
                                        { isEditing ? 'Save Changes' : 'Submit'}
                                </button>

                            </div>
                        </div>

                    </div>
                </form>
        </ModalShell>
    );
  };

export default CoManagerInfoModal;
